import { render, staticRenderFns } from "./RatingSystem.vue?vue&type=template&id=240697d4&scoped=true&"
import script from "./RatingSystem.vue?vue&type=script&lang=js&"
export * from "./RatingSystem.vue?vue&type=script&lang=js&"
import style0 from "./RatingSystem.vue?vue&type=style&index=0&id=240697d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240697d4",
  null
  
)

export default component.exports